// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__hn5sy","actions":"styles_actions__p2i6M"};